import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Button, Tooltip } from 'redpoints-front-components/index';

const ActionButton = ({ children, disabled, onClick }) => (
  <Button
    className="rp-links-management-btn reset-btn"
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </Button>
);

const LinksManagementViewerActionsButton = props => {
  const { disabled, title } = props;

  if (disabled) {
    return <ActionButton {...props} />;
  }

  return (
    <Tooltip overlayClassName="rp-links-management-tooltip" title={title}>
      <span>
        <ActionButton {...props} />
      </span>
    </Tooltip>
  );
};

LinksManagementViewerActionsButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
};

export default memo(LinksManagementViewerActionsButton);
